// extracted by mini-css-extract-plugin
module.exports = {"page":"DomainRegister_page_36RGI"};